import * as React from 'react';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../Types';
import { T } from '../../../../../../../../Translations';
import ClockIcon from '../../../../../../../Cutesies/ClockIcon';
import Hours from '../../../../../Hours';

export interface Props {
  resource: ExperienceResource;
}

const ExperienceHours: React.FC<Props> = ({ resource }) =>
  resource.payload.totalHours
    .map((totalHours) => {
      return (
        <div className="mb-5 flex">
          <Hours>
            <span className="mr-2">
              <ClockIcon />
            </span>
            <span>
              <T kind="{{count}} Hour" count={totalHours} />
            </span>
          </Hours>
        </div>
      );
    })
    .getOrElse(() => <></>);

export default observer(ExperienceHours);
